import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HelperFunctions } from 'bowman-commons';
import { Observable, Observer } from 'rxjs';
import { CustomizationConfiguration } from './model/customization-configuration';

@Injectable({
  providedIn: 'root',
})

export class CustomizationService {
  insertedElement: HTMLElement;
  private _mainUrl: string = window.location.pathname + '/configuration/';
  headers: HttpHeaders = new HttpHeaders();
  constructor(
    private _http: HttpClient,
  ) {

    this.headers.set("Accept", "application/json");
  }



  getCustomization(): Observable<CustomizationConfiguration> {
    const dataUrl = HelperFunctions.cleanUrl(this._mainUrl + 'customization.json');
    let headers = new HttpHeaders().set('Accept', 'application/json');
    return Observable.create((observer: Observer<CustomizationConfiguration>) => {
      this._http.get(dataUrl, { headers: headers }).subscribe(
        (data: CustomizationConfiguration) => {
          let customization: CustomizationConfiguration = data;

          if (customization.cssFilename != null && customization.cssFilename != '') {
            this.loadTheme(customization.cssFilename);
          }
          if (customization.title != null) {
            this.changeTitle(customization.title);
          }
          observer.next(customization);
          observer.complete();
        }, err => {
          observer.next(null);
          observer.complete();
        }
      );

    });
  }

  changeTitle(title: string): void {
    document.title = title;
  }

  loadTheme(cssFilename: string): void {
    const dataUrl = HelperFunctions.cleanUrl(this._mainUrl + cssFilename);
    let headers = new HttpHeaders().set('Accept', 'application/json');
    this._http.get(dataUrl, { headers: headers, responseType: 'text' as 'json' }).subscribe(
      (data) => {
        let test: CustomizationConfiguration = new CustomizationConfiguration();

        let cssData = data as string;
        this.insertToDom(cssData);
      }, err => {
        console.error("Css load error: ", err);
      }
    );
  }

  insertToDom = (content: string) => {
    const element = document.createElement('style');
    element.textContent = content;
    document.head.appendChild(element);
    if (this.insertedElement) this.insertedElement.remove();
    this.insertedElement = element;
  };
}
